import { ForgotPasswordSchema } from 'constants/ValidationSchema';
import { useFormik } from 'formik';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import FormInput from '../../components/FormInput';
import AuthLayout from '../../components/Layout/AuthLayout';
import { navLinks } from '../../constants/paths';
import { useResetPasswordMutation } from '../../redux/services/auth';

const ResetPassword = () => {
  const [resetPassword] = useResetPasswordMutation();
  const { t } = useTranslation();

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: ForgotPasswordSchema,
    onSubmit: async (values) => {
      const res: any = await resetPassword(values);
      if (res.data) {
        toast.success(t('reset_link_sent_success'));
      } else toast.error(res.error.data.message);
    },
  });

  const { errors, touched } = formik;
  return (
    <AuthLayout>
      <div className="lgBox">
        <h2>{t('forgot_password')}</h2>
        <p className="text-center tag-line invisible">{t('login_branding')}</p>
        <form onSubmit={formik.handleSubmit} noValidate className="mb-3">
          <FormInput
            label={t('your_registered_email')}
            type="email"
            name="email"
            value={formik.values.email}
            onChange={formik.handleChange}
            touched={touched.email}
            error={errors.email}
          />

          <button type="submit" className="btn btn-primary w-100">
            {t('request_reset_link')}
          </button>
        </form>

        <div className="form-group text-center">
          <Link to={navLinks.login}>{t('back_to_login')}</Link>
        </div>
      </div>
    </AuthLayout>
  );
};

export default ResetPassword;
